import { combineReducers } from 'redux';
import { UPDATE_OFFICE_KEY } from '../actions/index';
import { OficceInfoType } from '../types';

interface Action {
    type: string;
    payload?: OficceInfoType;
}

const initialState = {
    location: '',
    name: '',
    location_title: '',
    location_address: '',
    direction_url: '',
};
const infoOffice = (
    state: OficceInfoType = initialState,
    { type, payload = initialState }: Action,
): OficceInfoType => {
    let newState = state;

    if (type === UPDATE_OFFICE_KEY) {
        newState = payload;
    }
    return newState;
};
const noop = (state = {}) => state;
export default combineReducers({
    appName: noop,
    appVersion: noop,
    env: noop,
    featureFlags: noop,
    request: noop,
    payoutId: noop,
    infoOffice,
    infoTLD: noop,
});
